import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Box, ListItemText, List, ListItem } from '@mui/material';
import { Typography, colors, Button } from '@leapeasy/ui-kit';

import { setDataAction } from 'redux/actions/getFormActions';
import { sendEmailVerificationAction } from 'redux/actions/emailActions';
import { FiberManualRecord } from '@mui/icons-material';

const Form1 = (props) => {
  const { handleNext, handleBack } = props;

  const handleNextButton = () => {
    handleNext();
  };

  return (
    <Box display="flex" flexDirection="column" gap="12px" style={{ color: colors.purple[900] }}>
      <Typography variant="body1" style={{ fontWeight: '600' }}>
        Thank you!
      </Typography>

      <Box>
        <Typography variant="body1">
          Please consider these qualifications before applying.
        </Typography>
        <Typography variant="body1">If “yes”, you may continue with your application:</Typography>

        <List>
          <ListItem sx={{ padding: '0px 0px 4px 0px' }}>
            <ListItemText
              sx={{ m: 0 }}
              primary={
                <Box display="flex" alignItems="center" gap="4px">
                  <FiberManualRecord style={{ width: 12, height: 12 }} />
                  <Typography variant="body1">
                    Are you the resident/tenant on your lease?
                  </Typography>
                </Box>
              }
            />
          </ListItem>
          <ListItem sx={{ padding: '0px 0px 4px 0px' }}>
            <ListItemText
              sx={{ m: 0 }}
              primary={
                <Box display="flex" alignItems="center" gap="4px">
                  <FiberManualRecord style={{ width: 12, height: 12 }} />
                  <Typography variant="body1">
                    Were you referred to us by your potential landlord?
                  </Typography>
                </Box>
              }
            />
          </ListItem>
          <ListItem sx={{ padding: '0px 0px 0px 0px' }}>
            <ListItemText
              sx={{ m: 0 }}
              primary={
                <Box display="flex" alignItems="center" gap="4px">
                  <FiberManualRecord style={{ width: 12, height: 12 }} />
                  <Typography variant="body1">Are you 18 years old or older?</Typography>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Box>

      <Typography variant="small">
        ***Parents and guarantors cannot apply on behalf of somebody else. You may be asked to
        provide supporting documents. See our{' '}
        <a href="https://www.leapeasy.com/faqs/" target="_blank">
          FAQ
        </a>{' '}
        for details, or contact us at{' '}
        <a href="mailto:heretohelp@leapeasy.com">heretohelp@leapeasy.com</a> for questions.
      </Typography>

      <Box
        sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', mt: 2, gap: '16px' }}
      >
        <Button size="medium" variant="tertiary" onClick={handleBack} style={{ flexShrink: 2 }}>
          Back
        </Button>

        <Button
          size="medium"
          variant="primary"
          onClick={handleNextButton}
          style={{ flexShrink: 1 }}
        >
          <Typography variant="body1">Next</Typography>
        </Button>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    formData: state.formData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        setDataAction,
        sendEmailVerificationAction,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form1);
